import {
  Checkbox,
  FormControl,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { ListItemText } from '@mui/material';
import { MenuItem } from '@mui/material';
import { CessionsSummary } from 'lib/api/business/types';
import React from 'react';

type Props = {
  months: string[];
  setMonths: (months: string[]) => void;
  dataPayers: CessionsSummary['dataPayers'] | undefined;
};

const DetailsFilter: React.FC<Props> = ({ months, setMonths, dataPayers }) => {
  const handleSelectChange = (event: SelectChangeEvent<string[]>) => {
    const newSelectedMonths = Array.isArray(event.target.value)
      ? event.target.value
      : [event.target.value];
    const allSelectedAlready =
      months.includes('Últimos 24M') || months.includes('Últimos 12M');
    if (newSelectedMonths.length === 0) {
      return setMonths(['Últimos 24M']);
    }
    if (allSelectedAlready && newSelectedMonths.length > 1) {
      if (
        newSelectedMonths.includes('Últimos 24M') &&
        newSelectedMonths.includes('Últimos 12M')
      ) {
        const monthsCopy = [...newSelectedMonths];
        return setMonths([monthsCopy.pop()!]);
      }
      const newSelectedMonthsFiltered = newSelectedMonths.filter(
        (month: string) => month !== 'Últimos 24M' && month !== 'Últimos 12M',
      );
      return setMonths(newSelectedMonthsFiltered);
    }
    if (newSelectedMonths.includes('Últimos 24M')) {
      return setMonths(['Últimos 24M']);
    }

    if (newSelectedMonths.includes('Últimos 12M')) {
      return setMonths(['Últimos 12M']);
    }
    setMonths(newSelectedMonths);
  };

  const sortedKeysByDate = Object.keys(dataPayers || {});

  return (
    <FormControl fullWidth>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        style={{ width: '250px' }}
        multiple
        value={months}
        onChange={handleSelectChange}
        renderValue={(selected: string[]) => selected.join(', ')}
      >
        {sortedKeysByDate.map((data: string) => (
          <MenuItem key={data} value={data}>
            <Checkbox checked={months.indexOf(data) > -1} />
            <ListItemText primary={data} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DetailsFilter;
